import { render, staticRenderFns } from "./TableBarValue.vue?vue&type=template&id=148f9269&scoped=true"
import script from "./TableBarValue.vue?vue&type=script&lang=js"
export * from "./TableBarValue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "148f9269",
  null
  
)

export default component.exports